import { useParams,useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback} from 'react';
import { db, auth } from '../firebase';
import { doc, getDoc, collection, query, where, getDocs, addDoc, updateDoc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import './SpaceApp.css';
import { getSpaceTasks, updateSpaceTask } from './services/spaceTasksService';
import { 
 onSnapshot,
  serverTimestamp, 
} from 'firebase/firestore';
const SpaceDashboard = () => {
  const { spaceId, username } = useParams();
  const [space, setSpace] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [inviteEmail, setInviteEmail] = useState('');
  const [isInviting, setIsInviting] = useState(false);
  const navigate = useNavigate();
  // Define loadSpace outside useEffect so it can be called by handlers
  const loadSpaceData = useCallback(async () => {
    try {
      const sDoc = await getDoc(doc(db, "spaces", spaceId));
      if (sDoc.exists()) {
        setSpace({ id: sDoc.id, ...sDoc.data() });
      }
      
      const tSnap = await getDocs(query(
        collection(db, "space_tasks"), 
        where("spaceId", "==", spaceId)
      ));
      setTasks(tSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error("Error loading space:", err);
    }
  }, [spaceId]);

 /* Updated Real-time Listener in SpaceDashboard.js */
useEffect(() => {
  if (!spaceId) return;

  // Real-time Space Meta
  const unsubSpace = onSnapshot(doc(db, "spaces", spaceId), (d) => {
    if (d.exists()) setSpace({ id: d.id, ...d.data() });
  });

  // Real-time Tasks
  const q = query(collection(db, "space_tasks"), where("spaceId", "==", spaceId));
  const unsubTasks = onSnapshot(q, (snapshot) => {
    setTasks(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
  });

  return () => { unsubSpace(); unsubTasks(); };
}, [spaceId]);
// 🌟 2. Define Missing Functions
  const updateTaskStatus = async (taskId, newStatus) => {
    try {
      const taskRef = doc(db, "space_tasks", taskId);
      await updateDoc(taskRef, { status: newStatus });
      // No need to call loadSpaceData because onSnapshot updates automatically
    } catch (err) {
      console.error("Status update failed:", err);
    }
  };

  const handleInviteMember = async (e) => {
    e.preventDefault();
    if (!inviteEmail) return;
    setIsInviting(true);
    const functions = getFunctions();
    const addMemberFn = httpsCallable(functions, 'addMemberToSpace');
    try {
      await addMemberFn({ spaceId, email: inviteEmail });
      setInviteEmail('');
      alert("Member added!");
    } catch (error) {
      alert("Failed to invite: " + error.message);
    } finally {
      setIsInviting(false);
    }
  };
  

  if (!space) return <div className="loading">Initializing Team Environment...</div>;

  return (
    <div className="spaces-wrapper">
      <nav className="space-header">
        <h1>{space.name}</h1>
        {/* 🌟 THE DUAL SWITCH */}
          <div className="view-switch-container" style={{ marginBottom: 0 }}>
            <button 
              className="view-switch-btn" 
              onClick={() => navigate(`/${username}/spaces/${spaceId}`)}
            >
              MANAGE
            </button>
            <button className="view-switch-btn active">KANBAN</button>
          </div>
    
        <div style={{ display: 'flex', gap: '15px' }}>
          <form onSubmit={handleInviteMember} style={{ display: 'flex', gap: '5px' }}>
            <input 
              className="brutalist-input" 
              placeholder="teammate@email.com"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
            />
            <button type="submit" className="btn-action" disabled={isInviting}>INVITE</button>
          </form>
        </div>
      </nav>
<div className="kanban-container">
  {['todo', 'progress', 'done'].map(status => (
    <div className="kanban-col" style={{ background: '#161616', borderRadius: '8px', padding: '15px' }}>
  <h2 style={{ color: '#ffffff', borderBottom: '2px solid #D90429' }}>{status.toUpperCase()}</h2>
      {tasks.filter(t => (t.status || 'todo') === status).map(task => (
  <div 
  key={task.id} 
  className="space-task-card" 
  style={{ 
    background: '#1a1a1a', // 🌟 Deep surface black
    border: '2px solid #333', // 🌟 Rustic border
    padding: '15px',
    marginBottom: '15px',
    boxShadow: 'none' // 🌟 Ensure no AI glow
  }}
>
{/* Task Title in Rustic White */}
  <div style={{ 
    color: '#ffffff', 
    fontFamily: "'Syne', sans-serif", 
    fontSize: '1.1rem', 
    fontWeight: '700',
    marginBottom: '10px'
  }}>
    {task.title}
  </div>
          <div className="task-meta-info" style={{ fontSize: '0.8rem', color: '#a0a0a0' }}>
    {/* Assigned To Logic */}
    <div style={{ marginBottom: '4px' }}>
      <strong style={{ color: '#ffffff' }}>TO:</strong> {task.assignedToEmail || 'UNASSIGNED'}
    </div>
            {/* Assigned By Logic */}
    <div style={{ marginBottom: '4px' }}>
      <strong style={{ color: '#ffffff' }}>BY:</strong> {task.creatorEmail || 'SYSTEM'}
    </div>
            {/* Due Date with Rustic Red Accent */}
    <div style={{ 
      marginTop: '8px', 
      color: '#D90429', 
      fontWeight: '800',
      letterSpacing: '0.5px'
    }}>
      <strong style={{ color: '#ffffff' }}>DUE:</strong> {task.dueDate ? new Date(task.dueDate).toLocaleString() : 'PENDING'}
    </div>
  </div>

          {/* Kanban Navigation Arrows */}
  <div style={{ marginTop: '15px', display: 'flex', gap: '8px' }}>
     {status !== 'todo' && (
       <button className="btn-small-rustic" onClick={() => updateTaskStatus(task.id, 'todo')}>←</button>
     )}
     {status !== 'done' && (
       <button className="btn-small-rustic" onClick={() => updateTaskStatus(task.id, status === 'todo' ? 'progress' : 'done')}>→</button>
     )}
  </div>
</div>
      ))}
    </div>
  ))}
</div>
    </div>
  );
};

export default SpaceDashboard;
